"use client";

export default function BrowseErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex items-center justify-center h-full bg-white">
      <div className="text-center">
        <h2 className="text-lg font-semibold mb-2">Failed to load</h2>
        <p className="text-sm text-gray-500 mb-4">Could not load the ECG Library.</p>
        <button
          onClick={reset}
          className="px-4 py-2 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
        >
          Retry
        </button>
      </div>
    </div>
  );
}
